module.exports = ".modal-header {\n  border-top: 1px solid #e9ecef; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/forms/shared/header-title-task/header-title-task.component.scss
// module id = ./src/app/forms/shared/header-title-task/header-title-task.component.scss
// module chunks = main